export const Auth_DA = {
  // Sign up
  auth: {
    authcard: {
      unregistered: "Er du ikke tilmeldt endnu?",
      create: "Opret en konto",
      registered: "Er du allerede tilmeldt?",
      login: "Log ind",
      verify_email: "Vi har sendt en email med instruktioner til din e-mail:",
      forgot_password:
        "Indtast din e-mail du brugte til at tilmelde dig med, og vi sender dig en nulstillingskode.",
      or: "eller",
    },
    login: {
      headline: "Log ind på din bruger",
      forgot_password: "Glemt din adgangskode?",
    },
    livestream: {
      headline: "Registrer dig eller log ind for at deltage",
    },
    create: {
      headline: "Opret en ny bruger",
      password: {
        headline: "Password must consist of at least",
        characters: "min. 8 tegn",
        uppercase: "et stort bogstav",
        lowercase: "et lille bogstav",
        special: "et speciel tegn",
        number: "mindst et nummer",
        match: "adgangskoderne er ens",
      },
      profile: {
        headline: "Næsten færdig",
        input: {
          username: {
            label: "Vælg et unikt brugernavn",
            placeholder: "Indtast et brugernavn",
          },
        },
      },
      error: {
        invalid: "E-mailen er ikke gyldig",
      },
    },
    forgot: {
      headline: "Glemt adgangskode",
      error: {
        invalid: "E-mailen er ikke gyldig",
      },
    },
    verify: {
      headline: "Bekræft din e-mail adresse",
      validity:
        "Koden er gyldig i 10 minutter efter afsendelse. Hvis koden ikke virker, kan du anmode om en ny her:",
    },
    reset: {
      headline: "Nulstil din adgangskode",
      code: "Kode fra e-mail",
      digits: "Indtast den 6-cifret kode sendt til",
    },
    input: {
      email: {
        label: "Din e-mail adresse",
        placeholder: "F.eks. email@gmail.com",
      },
      username: {
        label: "E-mail eller brugernavn",
        placeholder: "Indtast din e-mail adresse eller brugernavn",
      },
      password: {
        label: "Adgangskode",
        placeholder: "Indtast din adgangskode",
        create: {
          label: "Vælg adgangskode",
          placeholder: "Vælg en unik adgangskode",
          error: "Adgangskoden lever ikke op til kravene",
        },
        repeat: {
          label: "Gentag adgangskode",
          placeholder: "Skriv den samme adgangskode igen",
          error: "Adgangskoderne er ikke ens",
        },
      },
      button: {
        login: "Log ind",
        create: "Opret bruger",
        reset: "Nulstil adgangskode",
        send_link: "Send link",
        cancel: "Annuller",
        quick_account: "Hurtig konto",
        request: "Anmod om en ny kode",
      },
    },
    terms: {
      1: "Ved at fortsætte bekræfter du vores",
      2: "Vilkår for brug",
      3: "og",
      4: "Privatlivspolitik",
      5: "samt bekræfter at du er mindst 13 år gammel",
    },
    toast: {
      password: {
        wrong:
          "Adgangskoden er forkert eller måske er dette ikke en bruger med en adgangskode.",
      },
      profile: {
        incomplete:
          "Din profil er ikke færdig. Udfyld resten for at færdiggøre din profil.",
      },
    },
    log_into: "Log ind i", // Will have the set brand name after "to"
    log_in_how: "Hvordan vil du gerne logge ind?",
    sign_up_how: "Hvordan vil du gerne oprette en bruger?",
    create_profile: "Opret din profil", // NEW
    // auth step 2
    small_info:
      "du kan altid ændre dit brugernavn, profilbillede og opdatere dine præferencer under dine profilindstillinger",
    pick_username: "Vælg et brugernavn",
    profile_image: "Profilbillede",
    personalize: {
      small: "Personliggør",
      large: "Personliggør din brugerprofil",
    },
    // ----
    // auth step 3
    all_set: "Nu er du klar!",
    start_info:
      "Start din rejse ved at forbinde dine spilkonti eller ved at udforske de forskellige challenges.",
    // ----
    methods: {
      button: "Log ind med",
      discord: {
        login: {
          loading: "Logger ind med Discord",
          success: "Log ind med Discord lykkedes, omdirigerer til startsiden.",
          failed: {
            token: "Kunne ikke logge ind med token, prøv igen senere",
            auth: "Kunne ikke godkende, prøv igen senere",
          },
        },
      },
      twitch: {
        login: {
          loading: "Logger ind med Twitch",
          success: "Log ind med Twitch lykkedes, omdirigerer til startsiden.",
          failed: {
            token: "Kunne ikke logge ind med token, prøv igen senere",
            auth: "Kunne ikke godkende, prøv igen senere",
          },
        },
      },
    },
  },
};
